import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as messageHelper from "../../helpers/messageHelper";
import * as resultCodes from "../../constants/resultCodes";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_CURRENCY:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let reloadRequests = [
                {
                    type: actionTypes.SAVE_ACTIVE_CURRENCY,
                    payload: {
                        currency: response.data
                    }
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];

            if (
                response.data.code !== state.pricing.mainCurrency.code ||
                response.data.rate !== state.pricing.mainCurrency.rate
            ) {
                reloadRequests.push({type: actionTypes.RELOAD_PRICE_SETTINGS_DATA});
            }

            return reloadRequests;
        case handlers.GET_ALL_CURRENCIES:
            if (!responseHelper.isGetAllCurrenciesFormatValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_CURRENCY_LIST,
                    payload: {
                        currencyList: response.data.currencies
                    }
                }
            ];
        case handlers.ADD_CURRENCY:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_CURRENCY_MODAL
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_CURRENCIES
                    },
                    method: handlers.GET_ALL_CURRENCIES,
                    tabId: 0
                }
            ];
        case handlers.EDIT_CURRENCY:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_CURRENCY_MODAL
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CURRENCY
                    },
                    method: handlers.GET_CURRENCY,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_CURRENCIES
                    },
                    method: handlers.GET_ALL_CURRENCIES,
                    tabId: 0
                }
            ];
        case handlers.SET_CURRENCY:
        case handlers.DELETE_CURRENCY:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CURRENCY
                    },
                    method: handlers.GET_CURRENCY,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_CURRENCIES
                    },
                    method: handlers.GET_ALL_CURRENCIES,
                    tabId: 0
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
